import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { getAuth } from './authStorage';

const BranchFilterContext = createContext({
  branches: [],
  selectedBranch: 'all',
  setSelectedBranch: () => {},
  setBranches: () => {},
});

// Only the primary Secretary (CEO) role can access /api/branches
export function isCeoUser() {
  return getAuth()?.user?.roles?.includes('Secretary') ?? false;
}

export function BranchFilterProvider({ children }) {
  const [branches, setBranchesState] = useState([]);
  const [selectedBranch, setSelectedBranchState] = useState('all');

  const setBranches = useCallback((list) => setBranchesState(list), []);
  const setSelectedBranch = useCallback((name) => setSelectedBranchState(name), []);

  const value = useMemo(
    () => ({ branches, selectedBranch, setSelectedBranch, setBranches }),
    [branches, selectedBranch, setSelectedBranch, setBranches],
  );

  return (
    <BranchFilterContext.Provider value={value}>
      {children}
    </BranchFilterContext.Provider>
  );
}

export function useBranchFilter() {
  return useContext(BranchFilterContext);
}
